import React from 'react';
import styled from 'styled-components';

import Divider from 'antd/es/divider';

import useWindowSize from 'hooks/useWindowSize';

import TotalCphGauge from 'components/charts/TotalCphGauge';
import PersonCphGauge from 'components/charts/PersonCphGauge';

const ChartWrapper = styled.div`
  // padding-bottom: 16px;
  flex: 1;

  & .ant-statistic {
    margin-top: -2.5vh !important;
    margin-left: -1px;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  & .ant-statistic-title {
    font-weight: 600;
    font-size: 1vw;
    line-height: 1.5vw;
    color: #828C94;
  }

  & .ant-statistic-content-value {
    font-weight: 600;
    font-size: 1.6vw;
    line-height: 2vw;
    color: #232526;
  }
`;

const ChartDivider = styled(Divider)`
  align-self: center;
  border-left: 1px solid #E4E8ED;
  height: ${props => props.height ? props.height + 'px' : '150px'};
`;

const DCStatsWrapper = styled.div`
  width: 100%;
  display: flex;

  & .ant-statistic-title {
    font-size: 0.8vw;
  }

  & .ant-statistic-content {
    line-height: 1.6vw;
  }

  & .ant-statistic-content-value {
    font-size: 1.34vw;
    line-height: 1.6vw;
  }
`;

const DcStats = ({ summary = {}, ...rest }) => {
  const windowSize = useWindowSize();
  const { tot_cph, max_cph, avg_cph_per_employee, max_cph_per_person } = summary;
  const width = Math.floor(windowSize.width / 11.5);
  const height = width + 10;
  const dividerHeight = width - Math.floor(width / 3);

  return (
    <DCStatsWrapper {...rest}>
      <ChartWrapper>
        <TotalCphGauge value={tot_cph} max={max_cph} config={{ width, height }} />
      </ChartWrapper>
      <ChartDivider type="vertical" height={dividerHeight} />
      <ChartWrapper>
        <PersonCphGauge value={avg_cph_per_employee} max={max_cph_per_person} config={{ width, height }} />
      </ChartWrapper>
    </DCStatsWrapper>
  );
};


export default DcStats;
